(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  // Force scroll to top when landing on product page from navigation
  (function() {
    var userHasScrolled = false;
    var cleanupDone = false;
    
    // Simple one-time scroll detection
    function detectUserScroll() {
      if (!cleanupDone && window.scrollY > 100) {
        userHasScrolled = true;
        cleanup();
      }
    }
    
    // Cleanup function to remove event listeners
    function cleanup() {
      if (cleanupDone) return;
      cleanupDone = true;
      window.removeEventListener('scroll', detectUserScroll);
      window.removeEventListener('wheel', detectUserScroll);
      window.removeEventListener('touchmove', detectUserScroll);
    }
    
    // Check if we should force scroll to top
    const shouldScrollToTop = sessionStorage.getItem('scrollToTopOnLoad');
    
    // Remove hash from URL if present (prevents scrolling to anchors)
    if (window.location.hash) {
      history.replaceState(null, null, window.location.pathname + window.location.search);
    }
    
    // Force scroll to top immediately
    if (window.scrollY !== 0) {
      window.scrollTo(0, 0);
    }
    
    // Listen for user scrolling with cleanup after 200ms
    window.addEventListener('scroll', detectUserScroll, { passive: true, once: false });
    window.addEventListener('wheel', detectUserScroll, { passive: true, once: false });
    window.addEventListener('touchmove', detectUserScroll, { passive: true, once: false });
    
    // One more scroll attempt after a tiny delay
    setTimeout(function() {
      if (!userHasScrolled && window.scrollY !== 0) {
        window.scrollTo(0, 0);
      }
    }, 50);
    
    // Cleanup after 200ms
    setTimeout(cleanup, 200);
    
    // Clean up sessionStorage flag
    if (shouldScrollToTop === 'true') {
      setTimeout(function() {
        sessionStorage.removeItem('scrollToTopOnLoad');
      }, 300);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
